import {BlockType} from '../../../constants/BlockType';
import {BuiltInControlTypes} from '../../../constants/BuiltInControlTypes';
import {TextBuiltInControl} from '../TextBuiltInControl';

export abstract class TextPaddingsBuiltInControl extends TextBuiltInControl {
  public getParentControlId(): string {
    return BuiltInControlTypes[BlockType.BLOCK_TEXT].INTERNAL_INDENTS;
  }
}
